import React from 'react';

import CustomEllipsisText from '../../../../components/CustomEllipsisText/CustomEllipsisText';

interface Props {
  caption: string;
  maxLines?: number;
  onCaptionPressed?: () => void;
  style?: React.CSSProperties;
}

const CommunityPostContent: React.FC<Props> = ({
  caption,
  // maxLines,
  onCaptionPressed,
  // style,
}) => (
  <div className="community-post-content-wapper" onClick={onCaptionPressed}>
    {/* <Linkify> */}
    {/* <Typography.Paragraph
        className="community-post-content"
        ellipsis={{
          rows: maxLines,
          expandable: true,
          symbol: 'See more',
        }}
        style={style}>
        {caption}
      </Typography.Paragraph> */}
    <CustomEllipsisText
      textClassName="community-post-content"
      charLimit={300}
      text={caption}
    />
    {/* </Linkify> */}
  </div>
);

export default CommunityPostContent;
